// Mock data for global categories and subcategories

import type { GlobalCategory, GlobalSubcategory, CategoryStats } from '@/types/category.types';

// ============================================================================
// GLOBAL CATEGORIES
// ============================================================================

export const mockGlobalCategories: GlobalCategory[] = [
  // Labour Categories
  {
    id: 'gc-1',
    name: 'Consulting',
    code: 'LAB-001',
    type: 'labour',
    description: 'Professional consulting services and advisory work',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 45,
  },
  {
    id: 'gc-2',
    name: 'Development',
    code: 'LAB-002',
    type: 'labour',
    description: 'Software development and engineering work',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 38,
  },
  {
    id: 'gc-3',
    name: 'Design',
    code: 'LAB-003',
    type: 'labour',
    description: 'UI/UX design and creative services',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 28,
  },
  {
    id: 'gc-4',
    name: 'Project Management',
    code: 'LAB-004',
    type: 'labour',
    description: 'Project coordination and management activities',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 42,
  },
  {
    id: 'gc-5',
    name: 'Quality Assurance',
    code: 'LAB-005',
    type: 'labour',
    description: 'Testing and quality assurance activities',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 22,
  },

  // Expense Categories
  {
    id: 'gc-6',
    name: 'Travel',
    code: 'EXP-001',
    type: 'expenses',
    description: 'Business travel expenses including flights, trains, and taxis',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 35,
  },
  {
    id: 'gc-7',
    name: 'Accommodation',
    code: 'EXP-002',
    type: 'expenses',
    description: 'Hotel and lodging expenses',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 30,
  },
  {
    id: 'gc-8',
    name: 'Software & Tools',
    code: 'EXP-003',
    type: 'expenses',
    description: 'Software licenses, subscriptions, and development tools',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 40,
  },
  {
    id: 'gc-9',
    name: 'Equipment',
    code: 'EXP-004',
    type: 'expenses',
    description: 'Hardware and equipment purchases',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 15,
  },
  {
    id: 'gc-10',
    name: 'Marketing & Events',
    code: 'EXP-005',
    type: 'expenses',
    description: 'Marketing materials, events, and promotional activities',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 12,
  },

  // Subcontractor Categories
  {
    id: 'gc-11',
    name: 'Technical Subcontractors',
    code: 'SUB-001',
    type: 'subcontractors',
    description: 'External technical specialists and contractors',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 25,
  },
  {
    id: 'gc-12',
    name: 'Creative Subcontractors',
    code: 'SUB-002',
    type: 'subcontractors',
    description: 'External designers, copywriters, and creative professionals',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 18,
  },

  // Overhead Categories
  {
    id: 'gc-13',
    name: 'Office Overhead',
    code: 'OVH-001',
    type: 'overhead',
    description: 'Office space, utilities, and general overhead',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 50,
  },
  {
    id: 'gc-14',
    name: 'Administrative',
    code: 'OVH-002',
    type: 'overhead',
    description: 'Administrative and support costs',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 48,
  },

  // Contingency Categories
  {
    id: 'gc-15',
    name: 'Risk Reserve',
    code: 'CON-001',
    type: 'contingency',
    description: 'Contingency budget for unforeseen costs',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    createdBy: 'System',
    usageCount: 35,
  },
];

// ============================================================================
// GLOBAL SUBCATEGORIES
// ============================================================================

export const mockGlobalSubcategories: GlobalSubcategory[] = [
  // Consulting Subcategories
  {
    id: 'gs-1',
    categoryId: 'gc-1',
    name: 'Strategy Consulting',
    code: 'LAB-001-01',
    description: 'Strategic planning and advisory',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 30,
  },
  {
    id: 'gs-2',
    categoryId: 'gc-1',
    name: 'Technical Consulting',
    code: 'LAB-001-02',
    description: 'Technical architecture and consulting',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 35,
  },
  {
    id: 'gs-3',
    categoryId: 'gc-1',
    name: 'Business Analysis',
    code: 'LAB-001-03',
    description: 'Requirements gathering and business analysis',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 28,
  },

  // Development Subcategories
  {
    id: 'gs-4',
    categoryId: 'gc-2',
    name: 'Frontend Development',
    code: 'LAB-002-01',
    description: 'UI development and frontend engineering',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 32,
  },
  {
    id: 'gs-5',
    categoryId: 'gc-2',
    name: 'Backend Development',
    code: 'LAB-002-02',
    description: 'Server-side development and APIs',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 35,
  },
  {
    id: 'gs-6',
    categoryId: 'gc-2',
    name: 'Database Development',
    code: 'LAB-002-03',
    description: 'Database design and optimization',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 25,
  },
  {
    id: 'gs-7',
    categoryId: 'gc-2',
    name: 'DevOps',
    code: 'LAB-002-04',
    description: 'CI/CD, infrastructure, and deployment',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 20,
  },

  // Design Subcategories
  {
    id: 'gs-8',
    categoryId: 'gc-3',
    name: 'UI Design',
    code: 'LAB-003-01',
    description: 'User interface design',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 25,
  },
  {
    id: 'gs-9',
    categoryId: 'gc-3',
    name: 'UX Research',
    code: 'LAB-003-02',
    description: 'User research and testing',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 22,
  },
  {
    id: 'gs-10',
    categoryId: 'gc-3',
    name: 'Brand Design',
    code: 'LAB-003-03',
    description: 'Brand identity and visual design',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 15,
  },

  // Travel Subcategories
  {
    id: 'gs-11',
    categoryId: 'gc-6',
    name: 'Flights',
    code: 'EXP-001-01',
    description: 'Air travel expenses',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 30,
  },
  {
    id: 'gs-12',
    categoryId: 'gc-6',
    name: 'Ground Transport',
    code: 'EXP-001-02',
    description: 'Taxis, trains, and car rentals',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 28,
  },
  {
    id: 'gs-13',
    categoryId: 'gc-6',
    name: 'Parking & Tolls',
    code: 'EXP-001-03',
    description: 'Parking fees and road tolls',
    status: 'active',
    isDefault: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 20,
  },

  // Software & Tools Subcategories
  {
    id: 'gs-14',
    categoryId: 'gc-8',
    name: 'Development Tools',
    code: 'EXP-003-01',
    description: 'IDEs, version control, and dev tools',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 35,
  },
  {
    id: 'gs-15',
    categoryId: 'gc-8',
    name: 'Design Software',
    code: 'EXP-003-02',
    description: 'Design and creative software licenses',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 25,
  },
  {
    id: 'gs-16',
    categoryId: 'gc-8',
    name: 'Cloud Services',
    code: 'EXP-003-03',
    description: 'Cloud hosting and infrastructure',
    status: 'active',
    isDefault: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    usageCount: 38,
  },
];

// ============================================================================
// CATEGORY STATS
// ============================================================================

export const mockCategoryStats: CategoryStats = {
  totalGlobal: mockGlobalCategories.length,
  totalProjectSpecific: 0, // Will be calculated per project
  totalActive: mockGlobalCategories.filter(c => c.status === 'active').length,
  totalArchived: mockGlobalCategories.filter(c => c.status === 'archived').length,
  mostUsedCategories: [
    { id: 'gc-13', name: 'Office Overhead', usageCount: 50 },
    { id: 'gc-14', name: 'Administrative', usageCount: 48 },
    { id: 'gc-1', name: 'Consulting', usageCount: 45 },
    { id: 'gc-4', name: 'Project Management', usageCount: 42 },
    { id: 'gc-8', name: 'Software & Tools', usageCount: 40 },
  ],
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

export function getGlobalCategoryById(id: string): GlobalCategory | undefined {
  return mockGlobalCategories.find(c => c.id === id);
}

export function getGlobalSubcategoriesByCategory(categoryId: string): GlobalSubcategory[] {
  return mockGlobalSubcategories.filter(s => s.categoryId === categoryId);
}

export function getGlobalCategoriesByType(type: string): GlobalCategory[] {
  return mockGlobalCategories.filter(c => c.type === type && c.status === 'active');
}

export function getDefaultGlobalCategories(): GlobalCategory[] {
  return mockGlobalCategories.filter(c => c.isDefault && c.status === 'active');
}

export function getDefaultGlobalSubcategories(): GlobalSubcategory[] {
  return mockGlobalSubcategories.filter(s => s.isDefault && s.status === 'active');
}
